import Work25 from "../../assests/Admin.png";
import Work23 from "../../assests/DRIVE.jpg";
import Work15 from "../../assests/FilterPro.png";
import Work18 from "../../assests/Sumz.png";
import Work22 from "../../assests/Tank.png";
import Work17 from "../../assests/TaskNew.png";
import Work12 from "../../assests/Theeth.png";
import Work30 from "../../assests/ai-spy.png";
import Work33 from "../../assests/alpinepro.png";
import Work32 from "../../assests/devto.png";
import Work19 from "../../assests/domiktut.png";
import Work299 from "../../assests/edu.png";
import Work20 from "../../assests/epizodk6.png";
import Work27 from "../../assests/exclusive.png";
import Work26 from "../../assests/game.png";
import Work99 from "../../assests/goodlife.png";
import Work2122 from "../../assests/hamar.png";
import Work78 from "../../assests/ielts.png";
import Work51 from "../../assests/kod.png";
import Work29 from "../../assests/leetcode.png";
import Work34 from "../../assests/legal.png";
import Work24 from "../../assests/mdk.png";
import Work31 from "../../assests/republic.png";
import Work1 from "../../assests/shoes.png";
import Work11 from "../../assests/telegram.png";
import Work21 from "../../assests/ud.png";

const Menu = [
  {
    id: 1,
    image: Work32,
    title: "DEV.TO",
    category: "Clone",
    link: "https://devto.casarte.by",
    link2: "https://github.com/Abdulazizcoderdim/devto-clone",
  },
  {
    id: 1,
    image: Work2122,
    title: "Hamar-Hadiya",
    category: "Clone",
    link: "https://www.hamar-hadiya.uz",
    link2: "https://www.hamar-hadiya.uz",
  },
  {
    id: 1,
    image: Work11,
    title: "Telegram Clone",
    category: "Clone",
    link: "https://telegram-clone-sepia-two.vercel.app",
    link2: "https://github.com/Abdulazizcoderdim/Telegram-Clone",
  },
  {
    id: 1,
    image: Work23,
    title: "Google Drive",
    category: "Clone",
    link: "https://google-drive-clone-19.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/Google-Drive-Clone",
  },
  {
    id: 1,
    image: Work299,
    title: "EduTrack Pro",
    category: "Clone",
    link: "https://crm-o-quv-markaz.vercel.app/",
    link2: "https://crm-o-quv-markaz.vercel.app/",
  },
  {
    id: 1,
    image: Work29,
    title: "Leet Code",
    category: "Clone",
    link: "https://algoarena.fun",
    link2: "https://algoarena.fun",
  },
  {
    id: 1,
    image: Work99,
    title: "Goodlife Shop",
    category: "E-Commerce",
    link: "https://goodlife.by",
    link2: "#",
  },
  {
    id: 1,
    image: Work27,
    title: "Exclusive Shop",
    category: "E-Commerce",
    link: "https://exclusivepro.vercel.app",
    link2: "https://github.com/Abdulazizcoderdim/exclusive-shop",
  },
  {
    id: 1,
    image: Work25,
    title: "Admin Dashboard",
    category: "E-Commerce",
    link: "https://admin-dashboard-19.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/Admin-Dashboardd",
  },
  {
    id: 1,
    image: Work30,
    title: "AI-Spy",
    category: "Branding",
    link: "https://sparkly-raindrop-7c9777.netlify.app",
    link2: "https://github.com/Abdulazizcoderdim/Ai-Spy",
  },
  {
    id: 1,
    image: Work51,
    title: "Kodzilla",
    category: "Branding",
    link: "https://kodzillapro.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/kodzilla",
  },
  {
    id: 1,
    image: Work34,
    title: "LegalGPT",
    category: "Branding",
    link: "https://legalgptpro.vercel.app/en",
    link2: "https://github.com/Abdulazizcoderdim/LegalGPT",
  },
  {
    id: 2,
    image: Work19,
    title: "Domiktut",
    category: "E-Commerce",
    link: "https://domiktut.ru/",
    link2: "",
  },
  {
    id: 2,
    image: Work78,
    title: "IELTS Mock",
    category: "Branding",
    link: "https://ieltsmock.vercel.app",
    link2: "https://github.com/Abdulazizcoderdim/ielstmocktest",
  },
  {
    id: 2,
    image: Work20,
    title: "Istom Shop",
    category: "E-Commerce",
    link: "https://istom-shop.ru/",
    link2: "",
  },
  {
    id: 1,
    image: Work18,
    title: "Summarize ",
    category: "Branding",
    link: "https://sumz19.netlify.app/",
    link2: "https://github.com/Abdulazizcoderdim/Sumz-AI",
  },

  // {
  //   id: 2,
  //   image: Work16,
  //   title: 'Case Cobra',
  //   category: 'E-Commerce',
  //   link: 'https://casecobra19.vercel.app/',
  //   link2: 'https://github.com/Abdulazizcoderdim/E-Commerce-casecobra',
  // },
  {
    id: 2,
    image: Work24,
    title: "MDK.PW",
    category: "Branding",
    link: "https://new-mdk-19.vercel.app",
    link2: "https://github.com/Abdulazizcoderdim/new-mdk",
  },
  // {
  //   id: 2,
  //   image: Work26,
  //   title: 'Quizz Test',
  //   category: 'Branding',
  //   link: 'https://quiz-app-19.vercel.app/',
  //   link2: 'https://github.com/Abdulazizcoderdim/Quiz-App',
  // },
  // {
  //   id: 2,
  //   image: Work20,
  //   title: 'Epizodk',
  //   category: 'E-Commerce',
  //   link: 'https://www.epizodk6.beget.tech/',
  //   link2: '',
  // },
  {
    id: 2,
    image: Work21,
    title: "Udevs",
    category: "Branding",
    link: "https://udevsio-abdulazizs-projects-07cd96ef.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/Udevs",
  },
  {
    id: 2,
    image: Work31,
    title: "Republic",
    category: "Branding",
    link: "https://republic-19.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/Republic",
  },
  {
    id: 2,
    image: Work26,
    title: "TRY2WIN",
    category: "Branding",
    link: "https://game-19.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/game",
  },
  {
    id: 2,
    image: Work33,
    title: "AlpinePro",
    category: "Branding",
    link: "https://aesthetic-sorbet-0362a3.netlify.app/",
    link2: "https://github.com/Abdulazizcoderdim/htmlandjavascript",
  },
  {
    id: 2,
    image: Work17,
    title: "FOREST INVERONMENTAL",
    category: "Branding",
    link: "https://tasknew19.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/TaskNew",
  },
  {
    id: 4,
    image: Work22,
    title: "АВТОРУСЬ TANK",
    category: "Branding",
    link: "https://tank19.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/-TANK",
  },
  {
    id: 3,
    image: Work15,
    title: "Filter Product",
    category: "E-Commerce",
    link: "https://filterproduct.vercel.app/",
    link2: "https://github.com/Abdulazizcoderdim/Filter-Product",
  },
  {
    id: 4,
    image: Work12,
    title: "Eco Dental",
    category: "E-Commerce",
    link: "https://medicene.vercel.app",
    link2: "https://github.com/Abdulazizcoderdim/Medicene",
  },
  {
    id: 5,
    image: Work1,
    title: "ReactJS shopping shoes",
    category: "E-Commerce",
    link: "https://taskfrontendcoder.netlify.app",
    link2: "",
  },

  // // {
  // //   id: 6,
  // //   image: Work8,
  // //   title: 'Online Shop',
  // //   category: 'E-Commerce',
  // //   link: 'https://taskfrontend19.netlify.app',
  // //   link2: '',
  // // },
  // {
  //   id: 7,
  //   image: Work14,
  //   title: 'BookShelf',
  //   category: 'Branding',
  //   link: 'https://book-shelf19.vercel.app/',
  //   link2: 'https://github.com/Abdulazizcoderdim/BookShelf',
  // },
  // // {
  // //   id: 8,
  // //   image: Work9,
  // //   title: 'Vex Products',
  // //   category: 'E-Commerce',
  // //   link: '',
  // //   link2: 'https://github.com/Abdulazizcoderdim/task-project-vex',
  // // },
  // {
  //   id: 9,
  //   image: Work13,
  //   title: 'Metsenat',
  //   category: 'Branding',
  //   link: 'https://metsenat19.vercel.app/',
  //   link2: 'ithub.com/Abdulazizcoderdim/Metsenat',
  // },
  // {
  //   id: 10,
  //   image: Work4,
  //   title: 'Portfolio WebSite',
  //   category: 'Branding',
  //   link: 'https://abdulazizrustamov.netlify.app',
  //   link2: '',
  // },
  // // {
  // //   id: 11,
  // //   image: Work10,
  // //   title: 'Uzum market Clone',
  // //   category: 'Clone',
  // //   link: 'https://uzum-shop-demo.vercel.app/',
  // //   link2: 'https://github.com/Abdulazizcoderdim/Uzum-shop-demo',
  // // },
  // {
  //   id: 12,
  //   image: Work6,
  //   title: 'Calculator',
  //   category: 'Small Projects',
  //   link: 'https://calculator111.netlify.app',
  //   link2: '',
  // },
  // {
  //   id: 14,
  //   image: Work2,
  //   title: 'Chess Game',
  //   category: 'Small Projects',
  //   link: 'https://chessgame1.netlify.app',
  //   link2: '',
  // },
  // {
  //   id: 15,
  //   image: Work3,
  //   title: 'Age Calculator',
  //   category: 'Small Projects',
  //   link: 'https://agecalculatorjs12.netlify.app',
  //   link2: '',
  // },
  // {
  //   id: 16,
  //   image: Work5,
  //   title: 'Pomidoro Timer',
  //   category: 'Small Projects',
  //   link: 'https://pomidorotimer11.netlify.app',
  //   link2: '',
  // },
];

export default Menu;
